import { useLogin } from '@ixigo-packages/login';
import { BottomNavigation, BottomNavigationItem } from '@ixigo/iui/BottomNavigation';
import { FC, useCallback, useEffect, useState } from 'react';
import { getWallet } from '../../apis/user';
import { getNavbarItems } from './helper';

const BottomNavigationBar: FC = () => {
    const { isUserLoggedIn } = useLogin();
    const [balance, setBalance] = useState<number>();

    const fetchBalance = useCallback(async () => {
        try {
            const response = await getWallet();
            setBalance(response);
        } catch (e) {
            // NoOp
        }
    }, []);

    useEffect(() => {
        if (!isUserLoggedIn) return;
        fetchBalance();
    }, [isUserLoggedIn, fetchBalance]);

    return (
        <div className='bg-white fixed bottom-0 w-full'>
            <BottomNavigation
                className='justify-around bg-primary border-t border-charcoal-100'
                onChange={(_e, value) => window.location.assign(value)}
                value='/support'
                showLabels
                variant='slim'
            >
                {getNavbarItems(balance).map((item) => (
                    <BottomNavigationItem
                        key={item.label}
                        icon={item.icon}
                        label={item.label}
                        value={item.href}
                        chipContent={item.chipContent || undefined}
                    />
                ))}
            </BottomNavigation>
        </div>
    );
};

export default BottomNavigationBar;
